import { API_BASE_URL } from "../../constants/index";
import { buildUrl } from "../../utilities/index";
import HttpInterface from "../../helpers/HttpInterface";

export class ArticlesService {
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  all(params = {}) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      buildUrl(`${API_BASE_URL}/logistic-service/articles`, params),
      requestOptions
    );
  }

  get(id) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/articles/${id}`,
      requestOptions
    );
  }

  create(article) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(article),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/articles`,
      requestOptions
    );
  }

  edit(article) {
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify(article),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/articles/${article.id}`,
      requestOptions
    );
  }

  delete(id) {
    const requestOptions = {
      method: "DELETE",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/articles/${id}`,
      requestOptions
    );
  }
}
